import { produce } from 'immer';

import {
    ConnectToZendeskResponse,
    TicketField,
} from '@/operator/services/hooks/connections/useConnectToCRMAPIResponse';
import { ConnectionSystem } from 'generated/graphql';

export enum PageStateActions {
    SetFormData,
    SetSelectedConnector,
}

export type FormData = {
    name: string;
    email: string;
    address: string;
    city: string;
    gender: string;
    age: string;
    subdomain: string;
    username: string;
    password: string;
    connectionData?: {
        loadedFromExistingConnection: boolean;
        custom_field_found: boolean;
        custom_fields: ConnectToZendeskResponse['custom_fields'];
    };
    auditData: boolean;
    eventData: boolean;
    existingData: number;
    totalTimeSpentCustomField?: TicketField;
    totalTimeLastUpdatedField?: TicketField;
};

export const DEFAULT_INITIAL_PAGE_STATE: {
    selectedConnector: ConnectionSystem;
    formData: FormData;
} = {
    selectedConnector: '' as ConnectionSystem,
    formData: {
        name: '',
        email: '',
        address: '',
        city: '',
        gender: '',
        age: '',
        subdomain: '',
        username: '',
        password: '',
        connectionData: {
            loadedFromExistingConnection: false,
            custom_field_found: false,
            custom_fields: [],
        },
        auditData: false,
        eventData: false,
        existingData: 0,
    },
};

export type PageStateAction = {
    type: PageStateActions;
    attribute?: keyof FormData;
    value: string | object | boolean | number;
};

export const pageStateReducer = produce((draft, action: PageStateAction) => {
    switch (action.type) {
        case PageStateActions.SetFormData: {
            const { attribute, value } = action;
            if (attribute) {
                draft.formData[attribute] = value;
            }
            return;
        }
        case PageStateActions.SetSelectedConnector: {
            const { value } = action;
            draft.selectedConnector = value;
            return;
        }
    }
});
